module.exports = __webpack_public_path__ + "img/summarize_img11.png";